'use client';

import { c as _c } from "react/compiler-runtime";
import { useToast } from '@common/hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AuthMutation, AuthQueryOptions } from '@/api';
import { useAdpopcornSspFullscreenAd } from '@/modules/adpopcorn-ssp';
import { ADPOPCORN_SSP_MODULE } from '@/modules/wello-app';
import { useAdpopcornSspPlacementId } from '../../_hooks/useAdpopcornSspPlacementId';
export const useAdBonusReward = () => {
  const $ = _c(19);
  const {
    toast
  } = useToast();
  const queryClient = useQueryClient();
  const placementId = useAdpopcornSspPlacementId(ADPOPCORN_SSP_MODULE.REWARD_VIDEO);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = AuthMutation["post:/wello/v2/auth/external/adpopcorn-ssp"]();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== queryClient || $[2] !== toast) {
    t1 = () => {
      toast({
        message: "\uD589\uC6B4\uAD8C\uC744 \uBC1B\uC558\uC5B4\uC694"
      });
      return Promise.all([queryClient.invalidateQueries({
        queryKey: AuthQueryOptions["get:/wello/v2/auth/benefit-tickets/lucky-ticket"]().queryKey
      }), queryClient.invalidateQueries({
        queryKey: AuthQueryOptions["get:/wello/v2/auth/benefit-tickets"]().queryKey
      })]);
    };
    $[1] = queryClient;
    $[2] = toast;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== toast) {
    t2 = () => {
      toast({
        message: "\uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694",
        type: "fail"
      });
    };
    $[4] = toast;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = {
      ...t0,
      onSuccess: t1,
      onError: t2
    };
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const {
    mutate: rewardBonusTicket,
    isPending: isRewarding
  } = useMutation(t3);
  let t4;
  if ($[9] !== placementId || $[10] !== rewardBonusTicket) {
    t4 = {
      autoShow: true,
      onCompleted: () => {
        rewardBonusTicket({
          body: {
            placementId,
            sspType: "REWARDED_VIDEO"
          }
        });
      }
    };
    $[9] = placementId;
    $[10] = rewardBonusTicket;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const {
    load,
    phase
  } = useAdpopcornSspFullscreenAd(ADPOPCORN_SSP_MODULE.REWARD_VIDEO, t4);
  let t5;
  if ($[12] !== load || $[13] !== placementId) {
    t5 = () => load(placementId);
    $[12] = load;
    $[13] = placementId;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== isRewarding || $[16] !== phase || $[17] !== t5) {
    t6 = {
      watchAd: t5,
      phase,
      isRewarding
    };
    $[15] = isRewarding;
    $[16] = phase;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};